import { getSelectedTableView } from 'owa-mail-list-store';
import type { ActionSource } from 'owa-analytics-types';
import { lazyReportItems } from 'owa-mail-triage-action';
import { ReportType } from 'owa-reporting';
import getEffectiveRowKeys from 'owa-mail-list-store/lib/utils/getEffectiveRowKeys';

export default function onMarkAsPhishing(
    actionSource: ActionSource,
    onReportCompleted?: (reportAttempted: boolean) => void
): void {
    const tableView = getSelectedTableView(true /*shouldGetEffectiveView*/);
    const rowKeys = getEffectiveRowKeys(tableView);

    void lazyReportItems
        .importAndExecute(ReportType.Phishing, rowKeys, tableView, actionSource)
        .then(reported => onReportCompleted?.(!!reported))
        .catch(() => onReportCompleted?.(false));
}
